var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 43L58.1842 47.8235L64.976 54.2941L45.7795 77.7192L32 43ZM61.7737 53.7626L57.7665 49.9499L50.818 55.7495L61.7737 53.7626ZM36.8905 45.7625L48.438 55.353L55.7607 49.2397L36.8905 45.7625ZM45.7317 72.6385L47.6113 57.0524L35.5808 47.0524L45.7317 72.6385ZM61.4822 55.6754L49.3517 57.8759L47.5721 72.6517L61.4822 55.6754Z",
    fill: "#AAAAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.682 65.4926V51.3878H147.636V70.6255L133.839 55.2746V69.3836H131.894V50.1461L145.682 65.4926Z",
    fill: "#AAAAB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2138 51.3878H71.4677V53.3225H87.2138V51.3878Z",
    fill: "#AAAAB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5597 56.7387H76.6279V69.3706H78.5597V56.7387Z",
    fill: "#AAAAB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1174 56.7387H82.0492V69.3706H80.1174V56.7387Z",
    fill: "#AAAAB6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.418 69.3836H137.368V61.7757L135.418 59.6059V69.3836Z",
    fill: "#AAAAB6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.98 60.377C117.98 59.6624 118.558 59.0829 119.272 59.0829C119.985 59.0829 120.564 59.6624 120.564 60.377C120.564 61.0916 119.985 61.6712 119.272 61.6712C118.558 61.6712 117.98 61.0916 117.98 60.377Z",
    fill: "#AAAAB6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.272 51.3792C114.316 51.3792 110.287 55.4141 110.287 60.377C110.287 65.34 114.316 69.375 119.272 69.375C124.228 69.375 128.257 65.34 128.257 60.377C128.257 55.4184 124.228 51.3792 119.272 51.3792ZM119.272 67.4359C115.386 67.4359 112.223 64.2725 112.223 60.377C112.223 56.4816 115.382 53.3181 119.272 53.3181C123.157 53.3181 126.32 56.4816 126.32 60.377C126.32 64.2682 123.157 67.4359 119.272 67.4359Z",
    fill: "#AAAAB6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.906 56.9087C106.906 53.8672 104.452 51.3922 101.437 51.3922H91.1602V69.388H93.079V53.3444H101.437C103.373 53.3444 104.948 54.9435 104.948 56.9087C104.948 58.865 103.395 60.4555 101.476 60.4772L94.6584 60.473V69.388H96.5771V62.425H101.072L104.744 69.3836H106.976L103.143 62.1505C105.357 61.4141 106.906 59.2703 106.906 56.9087Z",
    fill: "#AAAAB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/tron.fbbdf1e1e0304a4758984504492552fb.svg";
export { ForwardRef as ReactComponent };